import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Alert, Card, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { baseUrl_SPB } from '../../../BaseUrl';
import axios from 'axios';

const EmergencyContactPanel = ({ employee, token, onUpdate }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    form.setFieldsValue({
      name: employee?.emergencyContact?.name || employee?.emergencyContact?.contactName || '',
      phone: employee?.emergencyContact?.phone || employee?.emergencyContact?.contactNumber || '',
      email: employee?.emergencyContact?.email || employee?.emergencyContact?.contactEmail || '',
      address: employee?.emergencyContact?.address || employee?.emergencyContact?.contactAddress || '',
    });
  }, [employee, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      setError('');

      await axios.post(
        `${baseUrl_SPB}/api/v1/user/emergency-contact/employees/${employee.id}`,
        {
          name: values.name,
          phone: values.phone,
          email: values.email,
          address: values.address,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      onUpdate?.();
    } catch (err) {
      if (err?.errorFields) return;
      setError('Failed to save emergency contact details.');
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card size="small">
      <Space direction="vertical" style={{ width: '100%' }} size={16}>
        {error && <Alert type="error" showIcon message={error} closable onClose={() => setError('')} />}

        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Emergency contact name"
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input placeholder="Contact name" />
          </Form.Item>

          <Form.Item
            name="phone"
            label="Contact number"
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input placeholder="Contact number" />
          </Form.Item>

          <Form.Item
            name="email"
            label="Contact email"
            rules={[{ required: true, type: 'email', message: 'Enter a valid email' }]}
          >
            <Input placeholder="Contact email" />
          </Form.Item>

          <Form.Item
            name="address"
            label="Contact address"
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input.TextArea rows={3} placeholder="Contact address" />
          </Form.Item>

          <Button type="primary" icon={<SaveOutlined />} loading={saving} onClick={handleSave}>
            Save emergency contact
          </Button>
        </Form>
      </Space>
    </Card>
  );
};

export default EmergencyContactPanel;